import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabase.js';
import { getWorkConversation } from '../messages/messages.js';
import { Thread } from '../messages/Thread.jsx';

/** Messages section on /work/:id: the conversation between the customer and the chosen supplier. */
export function WorkConversation({ work }) {
  const [conversationId, setConversationId] = useState(null), [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    getWorkConversation(supabase, work.id).then(row => { if (active) { setConversationId(row.id); setError(''); } }).catch(cause => { if (active) setError(cause.message); });
    return () => { active = false; };
  }, [work.id]);
  return <section className="account-content-panel" aria-labelledby="work-messages-heading">
    <h2 id="work-messages-heading">Messages</h2>
    {error ? <p role="alert">{error}</p> : !conversationId ? <p>Loading messages…</p> : <>
      <Thread conversationId={conversationId} compact />
      <p><Link to={`/messages/${conversationId}`}>Open full conversation</Link></p>
    </>}
  </section>;
}
